var exports = {
  "r": "ActiveNowTab.module__cooldownHint___eDZoNk",
};

module.exports = exports;
